export default __webpack_public_path__ + "static/media/Animations_Bar10.95c0c9cf.svg";